import{_ as s}from"./_assocIndexOf.js";var a=s;var r=function(s,r){var t=this.__data__,_=a(t,s);return _<0?(++this.size,t.push([s,r])):t[_][1]=r,this};export{r as _};
